<template>
    <div class="insta-carousel">
        <scroll-to-me @trigger-animate="triggerInstaTitle">
            <h3 class="insta-carousel__title" data-anime="fade-up" :class="{animate: showTitle}">Siga-nos</h3>
        </scroll-to-me>

        <scroll-to-me @trigger-animate="triggerInstaSubtitle">
            <h2 class="insta-carousel__subtitle" data-anime="fade-up" :class="{animate: showSubtitle}">
                {{$root.commonTexts['home.intagram.titulo']}}</h2>
        </scroll-to-me>

        <scroll-to-me @trigger-animate="triggerInstaText">
            <p class="insta-carousel__text" data-anime="fade-up" :class="{animate: showText}">
                {{$root.commonTexts['home.intagram.texto']}}</p>
        </scroll-to-me>

        <scroll-to-me @trigger-animate="triggerInstaContent" v-if="instagram.length">
            <div class="carousel-container" :class="{animate: showContent}" data-anime="fade-up">
                <carousel :navigationEnabled="true"
                          :perPageCustom="[[300, 1], [768, 2], [1024, 2], [1280, 3], [1366, 4]]"
                          :autoplay="true"
                          :autoplayTimeout="3000"
                          :speed="1000"
                          :loop="true"
                          :paginationEnabled="false">
                    <slide v-for="slide in instagram" :key="slide.id">
                        <a :href="slide.url" class="item" v-if="slide.file" target="_blank">
<!--                            <img class="item__img" :src="slide.file.permalink" alt="">-->
                            <lazy-image class="item__img" :image="slide.file" />
                        </a>
                    </slide>
                </carousel>
            </div>
        </scroll-to-me>
    </div>
</template>

<script>
    import {Carousel, Slide} from 'vue-carousel';
    import ScrollToMe from "./ScrollToMe";
    import LazyImage from "./LazyImage";

    export default {
        name: "InstaCarousel",
        data() {
            return {
                showTitle: false,
                showSubtitle: false,
                showText: false,
                showContent: false,
                instagram: [],
            }
        },
        components: {
            Carousel,
            Slide,
            ScrollToMe,
            LazyImage
        },
        methods: {
            fetchInstagram() {
                axios.get('/instagram')
                    .then(r => {
                        this.instagram = r.data.data;
                    })
            },
            triggerInstaTitle() {
                this.showTitle = true;
            },
            triggerInstaSubtitle() {
                this.showSubtitle = true;
            },
            triggerInstaText() {
                this.showText = true;
            },
            triggerInstaContent() {
                this.showContent = true;
            }
        },
        created() {
            this.fetchInstagram();
        }
    }
</script>

<style lang="scss" scoped>
    .insta-carousel {
        width: 100%;
        position: relative;
        margin: 80px auto;

        &__title {
            text-align: center;
            font-family: 'Open Sans';
            font-weight: 400;
            font-size: 1.125rem;
            margin-bottom: 10px;
        }

        &__subtitle {
            margin-bottom: 20px;
            font-family: 'HelveticaNeue', Arial, sans-serif;
            font-weight: 500;
            font-size: 2rem;
            text-align: center;
        }

        &__text {
            font-family: 'Open Sans';
            font-weight: 400;
            padding: 0 15px;
            font-size: 1rem;
            text-align: center;
            margin-bottom: 60px;
        }
    }

    .carousel-container {
        max-width: 1140px;
        margin: 0 auto;
    }

    .item {
        display: block;
        width: 270px;
    }

    ::v-deep .item img {
        width: 270px;
        height: 270px;
        object-fit: cover;
    }

    @media only screen and(max-width: 1366px) {
        .insta-carousel {
            max-width: 840px;
        }
    }

    @media only screen and(max-width: 1200px) {
        .insta-carousel {
            max-width: 560px;
        }
    }

    @media only screen and (max-width: 767px) {
        .insta-carousel {
            max-width: 300px;
            margin-bottom: 120px;
        }

        .item {
            margin: 0 auto;
        }
    }
</style>